module.exports = __webpack_public_path__ + "static/img/18.27a8aa8c.png";